/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Artifactpacksampleerror3Inputs */

const en_artifactpacksampleerror3 = /** @type {(inputs: Artifactpacksampleerror3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Couldn't open the sample. Try again.`)
};

const pt_artifactpacksampleerror3 = /** @type {(inputs: Artifactpacksampleerror3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não foi possível abrir o exemplo. Tente novamente.`)
};

/**
* | output |
* | --- |
* | "Couldn't open the sample. Try again." |
*
* @param {Artifactpacksampleerror3Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const artifactpacksampleerror3 = /** @type {((inputs?: Artifactpacksampleerror3Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Artifactpacksampleerror3Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_artifactpacksampleerror3(inputs)
	return pt_artifactpacksampleerror3(inputs)
});
export { artifactpacksampleerror3 as "artifactPackSampleError" }